/* East Asia Whisky — theme scripts (no dependencies) */
(function () {
  'use strict';

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  /* Age gate */
  var gate = document.getElementById('AgeGate');
  if (gate && store('eaw_age_ok') !== '1') {
    gate.hidden = false;
    var yes = gate.querySelector('[data-age-yes]');
    if (yes) {
      yes.focus();
      yes.addEventListener('click', function () {
        store('eaw_age_ok', '1');
        gate.hidden = true;
      });
    }
  }

  /* Tabs: [data-tabs] > [role=tab][aria-controls] */
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    var tabs = wrap.querySelectorAll('[role="tab"]');
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      var note = wrap.querySelector('[data-tab-note]');
      if (note && tab.dataset.note) note.textContent = tab.dataset.note;
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        next.focus(); select(next);
      });
    });
  });

  /* Rare bottle enquiry: clicking Enquire fills the form */
  document.querySelectorAll('[data-rare]').forEach(function (wrap) {
    var title = wrap.querySelector('[data-enquiry-title]');
    var field = wrap.querySelector('[data-enquiry-bottle]');
    var buttons = wrap.querySelectorAll('[data-enquire]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('btn--accent', on);
          b.classList.toggle('btn--secondary', !on);
          b.textContent = on ? 'Selected' : 'Enquire';
          b.closest('.rare-row').classList.toggle('is-selected', on);
        });
        if (title) title.textContent = btn.dataset.enquire;
        if (field) field.value = btn.dataset.enquire;
        var form = wrap.querySelector('[data-enquiry-form] input[type="text"]');
        if (form && window.innerWidth < 1100) form.focus();
      });
    });
  });

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = b.dataset.step === 'up' ? v + 1 : Math.max(1, v - 1);
        var max = parseInt(input.max, 10);
        if (max && v > max) v = max;
        input.value = v;
      });
    });
  });

  /* Collection sort */
  document.querySelectorAll('form[data-sort] select').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  /* Cart: 18+ declaration gates checkout */
  var ageBox = document.querySelector('[data-cart-age]');
  var checkout = document.querySelector('[data-checkout]');
  if (ageBox && checkout) {
    var sync = function () { checkout.disabled = !ageBox.checked; };
    ageBox.addEventListener('change', sync); sync();
  }

  /* Vintage chart */
  document.querySelectorAll('[data-vchart]').forEach(function (chart) {
    var rows = chart.querySelectorAll('.vrow');
    var chips = chart.querySelectorAll('[data-filter]');
    var d = chart.querySelector('[data-detail]');
    function show(row) {
      rows.forEach(function (r) { r.classList.toggle('is-selected', r === row); });
      if (!d) return;
      var set = function (sel, val) { var el = d.querySelector(sel); if (el) el.textContent = val; };
      set('[data-d-name]', row.dataset.name);
      set('[data-d-cat]', row.dataset.catLabel);
      set('[data-d-year]', row.dataset.year || 'To be confirmed');
      set('[data-d-cask]', row.dataset.cask || '—');
      set('[data-d-award]', row.dataset.award || '—');
      var dot = d.querySelector('[data-d-dot]'); if (dot) dot.style.background = row.dataset.color;
      var link = d.querySelector('[data-d-link]');
      if (link) { if (row.dataset.url) { link.href = row.dataset.url; link.hidden = false; } else { link.hidden = true; } }
      var img = d.querySelector('[data-d-img]');
      if (img) {
        if (row.dataset.img) { img.src = row.dataset.img; img.alt = row.dataset.name; img.hidden = false; }
        else { img.hidden = true; }
      }
    }
    rows.forEach(function (r) {
      r.addEventListener('click', function () { show(r); });
      r.addEventListener('mouseenter', function () { show(r); });
      r.addEventListener('focus', function () { show(r); });
    });
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.dataset.filter;
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        rows.forEach(function (r) { r.classList.toggle('is-dim', f !== 'all' && r.dataset.cat !== f); });
      });
    });
    var first = chart.querySelector('.vrow.is-selected') || rows[0];
    if (first) show(first);
  });

  /* Cask journey */
  document.querySelectorAll('[data-journey]').forEach(function (j) {
    var steps = j.querySelectorAll('.journey__step');
    var panels = j.querySelectorAll('[data-journey-panel]');
    var bar = j.querySelector('.journey__progress');
    var idx = 0;
    function go(i) {
      idx = (i + steps.length) % steps.length;
      steps.forEach(function (s, k) {
        s.setAttribute('aria-selected', k === idx ? 'true' : 'false');
        s.classList.toggle('is-done', k < idx);
        s.tabIndex = k === idx ? 0 : -1;
      });
      panels.forEach(function (p, k) { p.hidden = k !== idx; });
      if (bar) bar.style.width = ((idx + 1) / steps.length * 100) + '%';
    }
    steps.forEach(function (s, k) { s.addEventListener('click', function () { go(k); }); });
    var prev = j.querySelector('[data-journey-prev]');
    var next = j.querySelector('[data-journey-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    go(0);
  });
})();

/* Auto-frame product photos: trims white space and centres every bottle with the same margin */
(function () {
  var MARGIN = 0.08;
  function frame(img) {
    var box = img.closest('.media');
    if (!box || box.dataset.framed) return;
    box.dataset.framed = '1';
    var run = function () {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h) return;
      var u;
      try { u = new URL(img.currentSrc || img.src, location.href); u.searchParams.set('width', '200'); u.searchParams.delete('height'); }
      catch (e) { return; }
      var a = new Image();
      a.crossOrigin = 'anonymous';
      a.onload = function () {
        var cw = a.naturalWidth, ch = a.naturalHeight;
        var c = document.createElement('canvas'); c.width = cw; c.height = ch;
        var ctx = c.getContext('2d'); ctx.drawImage(a, 0, 0);
        var d; try { d = ctx.getImageData(0, 0, cw, ch).data; } catch (e) { return; }
        var cols = new Array(cw).fill(0), rows = new Array(ch).fill(0);
        for (var y = 0; y < ch; y++) for (var x = 0; x < cw; x++) {
          var i = (y * cw + x) * 4;
          if (0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2] < 236) { cols[x]++; rows[y]++; }
        }
        var tc = Math.max(1, ch * 0.01), tr = Math.max(1, cw * 0.01);
        var x0 = cols.findIndex(function (v) { return v > tc; }), y0 = rows.findIndex(function (v) { return v > tr; });
        if (x0 < 0 || y0 < 0) return;
        var x1 = cw - 1; while (x1 > x0 && cols[x1] <= tc) x1--;
        var y1 = ch - 1; while (y1 > y0 && rows[y1] <= tr) y1--;
        var fx0 = x0 / cw, fx1 = (x1 + 1) / cw, fy0 = y0 / ch, fy1 = (y1 + 1) / ch;
        var r = box.getBoundingClientRect(), Bw = r.width, Bh = r.height;
        if (!Bw || !Bh) return;
        var medalCol = box.querySelector('.medal-stack') ? 0.24 : 0;
        var s = Math.min(Bw * (1 - medalCol - 2 * MARGIN) / ((fx1 - fx0) * w), Bh * (1 - 2 * MARGIN) / ((fy1 - fy0) * h));
        var rw = w * s, rh = h * s;
        if (rw / Bw > 4) return;
        var left = Bw * (1 - medalCol) / 2 - (fx0 + fx1) / 2 * rw, top = Bh / 2 - (fy0 + fy1) / 2 * rh;
        img.style.width = (rw / Bw * 100) + '%';
        img.style.height = (rh / Bh * 100) + '%';
        img.style.left = (left / Bw * 100) + '%';
        img.style.top = (top / Bh * 100) + '%';
        box.classList.add('is-framed');
      };
      a.src = u.toString();
    };
    if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
  }
  function all() {
    document.querySelectorAll('.product-card .media > img, .rare-row__media > img, .product__gallery .media > img, .tl__media > img').forEach(frame);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
})();

/* Release timeline arrows */
document.querySelectorAll('[data-timeline]').forEach(function (t) {
  var s = t.querySelector('[data-tl-scroll]');
  if (!s) return;
  var step = function () { var i = s.querySelector('.tl__item'); return i ? (i.getBoundingClientRect().width + 28) * 2 : 400; };
  var p = t.querySelector('[data-tl-prev]'), n = t.querySelector('[data-tl-next]');
  if (p) p.addEventListener('click', function () { s.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (n) n.addEventListener('click', function () { s.scrollBy({ left: step(), behavior: 'smooth' }); });
});

